// This file is generated by next-core EcmascriptClientReferenceModule.
import { registerClientReference } from "react-server-dom-turbopack/server";
export const Reveal = registerClientReference(
    function() { throw new Error("Attempted to call Reveal() from the server but Reveal is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/components/Reveal.tsx",
    "Reveal",
);
export const RevealText = registerClientReference(
    function() { throw new Error("Attempted to call RevealText() from the server but RevealText is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/components/Reveal.tsx",
    "RevealText",
);
